<template>
  <div>
    <div v-for="(section, s) in page.sections" :key="s">
      <section-header
        v-if="section.type === 'header'"
        v-model="section.data"
      ></section-header>
      <section-about
        v-if="section.type === 'about'"
        v-model="section.data"
      ></section-about>
      <section-features
        v-if="section.type === 'features'"
        v-model="section.data"
      ></section-features>
      <section-video
        v-if="section.type === 'video'"
        v-model="section.data"
      ></section-video>
      <section-cta
        v-if="section.type === 'cta'"
        v-model="section.data"
      ></section-cta>
      <section-divider
        v-if="section.type === 'divider'"
        v-model="section.data"
      ></section-divider>
      <section-clients
        v-if="section.type === 'clients'"
        v-model="section.data"
      ></section-clients>
    </div>
  </div>
</template>

<script>
import About from "@/components/page/About";
import Features from "@/components/page/Features";
import Video from "@/components/page/Video";
import CTA from "@/components/page/CTA";
import Header from "@/components/page/Header";
import Divider from "@/components/page/Divider";
import Clients from "@/components/page/Clients";
export default {
  props: ["value"],
  name: "PagePreview",
  components: {
    sectionAbout: About,
    sectionFeatures: Features,
    sectionVideo: Video,
    sectionCta: CTA,
    sectionHeader: Header,
    sectionDivider: Divider,
    sectionClients: Clients,
  },
  computed: {
    page() {
      return this.value;
    },
  },
};
</script>

<style>
</style>